<template>
  <div>
    <el-form @submit.native.prevent="createTag">
      <el-autocomplete
        v-model="tagLabel"
        :trigger-on-focus="false"
        :highlight-first-item="highlightFirstItem"
        :fetch-suggestions="tagsFilter"
        ref="autocomplete"
        prefix-icon="el-icon-plus"
        :placeholder="autocompletePlaceholder"
        @keyup.enter.native=""
        @select="selectTag"></el-autocomplete>
        <!-- {{ tag }} -->
    </el-form>
    <div class="m-t-10">
      <el-select
        v-model="selectedTag"
        @change="selectTagFromList"
        filterable
        :placeholder="selectPlaceholder">
        <el-option
          v-for="item in tags"
          :key="item.value"
          :label="item.label"
          :value="item">
        </el-option>
      </el-select>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'story-tag-selector',
    props: {
      tag: Object,
      selectFunction: Function,
      createFunction: Function,
      schemes: String,
      highlightFirstItem: {
        type: Boolean,
        default: true
      },
      autocompletePlaceholder: {
        type: String,
        default: 'Créer'
      },
      selectPlaceholder: {
        type: String,
        default: 'Liste'
      },

    },
    data () {
      return {
        tagLabel: null,
        tags: [],
        selectedTag: null
      }
    },
    watch: {
      'tag' (to, from) {
        if (to) {
          this.tagLabel = to.label
        }
      }
    },
    created () {
      this.init()
    },
    methods: {
      init () {
        let _this = this
        this.axios.get('/tags/', {
          params: {
            status: 'ENABLED',
            schemes: this.schemes,
            per_page: 10000},
          headers: {'x-fields': 'id,label,scheme'}
        }).then((response) => {
          response.data.results.map(function (value, key) {
            _this.tags.push({label: `${value.label} (${_this.$i18n.translate(value.scheme)})`, id: value.id, tag: value})
          })
        })
      },
      tagsFilter(queryString, cb) {
        let _this = this
        if (queryString) {
          this.axios.get('/tags/', {
            params: {
              term: queryString,
              status: 'ENABLED',
              schemes: this.schemes,
              per_page: 100},
            headers: {'x-fields': 'id,label,scheme'}
          }).then((response) => {
            var list = []
            response.data.results.map(function (value, key) {
              list.push({value: `${_this.$i18n.translate(value.scheme)} : ${value.label}`, id: value.id, tag: value})
            })
            cb(list)
          })
        }
      },
      selectTag(value) {
        if (value) {
          this.selectFunction(value.tag)
        }
      },
      selectTagFromList(value) {
        if (value) {
          this.selectFunction(value.tag)
        }
        this.selectedTag = null
      },
      createTag(value) {
        if (this.tagLabel) {
          this.createFunction(this.tagLabel)
        }
      },
      clearInput() {
        this.tagLabel = ''
      }
    }
  }
</script>
<style scoped>

.el-autocomplete {
  display: block;
}
</style>
